const countries = {
  US: 'US',
  UK: 'UK',
  FR: 'FR',
  EU: 'EU',
  DE: 'DE',
};

export default countries;
